<div class="loader-wrapper" [class.loderhide]="!show">
  <div>
    <nz-spin></nz-spin>
    <p class="text-white mt-7">Loading...</p>
  </div>
</div>
